module.exports = __webpack_public_path__ + "img/key-content.fdcc4d4e.png";